export default __webpack_public_path__ + "static/media/backw.c73c1591.svg";